var Company = /* @__PURE__ */ ((Company2) => {
  Company2["WEBSUPPORT"] = "ws";
  Company2["LOOPIA"] = "lp";
  return Company2;
})(Company || {});
var CompanyId = /* @__PURE__ */ ((CompanyId2) => {
  CompanyId2["WEBSUPPORT_SK"] = "sk-ws";
  CompanyId2["SK_WEBSUPPORT_CZ"] = "cz-ws";
  CompanyId2["WEBSUPPORT_HU"] = "hu-ws";
  CompanyId2["WEBSUPPORT_SE"] = "se-ws";
  CompanyId2["SK_WEBSUPPORT_HU"] = "hu-skws";
  CompanyId2["ACTIVE_24_SK"] = "sk-a24";
  CompanyId2["ACTIVE_24_CZ"] = "cz-a24";
  CompanyId2["SK_WEBSUPPORT_AT"] = "at-ws";
  CompanyId2["LOOPIA_SE"] = "se-lp";
  CompanyId2["LOOPIA_NO"] = "no-lp";
  CompanyId2["ACTIVE_24_WE"] = "we-a24";
  return CompanyId2;
})(CompanyId || {});
export {
  Company,
  CompanyId
};
//# sourceMappingURL=companies.enum.es.js.map
